import { SET_BOARDS } from './mutations-types'

const mutations = {
  [SET_BOARDS]: (state, payload) => {
    state.boards = payload
  }
}

export default mutations
